import Logo from 'components/Logo';
import './opengraph.css';

export const Opengraph = () => {
    return (
        <div className="solutions">
            <div className="opengraph-logo">
                <Logo />
            </div>
            <p className="opengraph-font">
                Climate
                <br /> <span className="color-text">is changing.</span>
            </p>
            <p className="opengraph-font opengraph-text">
                We’re{' '}
                <span className="color-text">
                    changing
                    <br />
                </span>{' '}
                faster.
            </p>
        </div>
    );
};
